export const MAPPING_REVIEW_PAGE_SIZE = 10;

export const MAPPING_REVIEW_STATUS_OPTIONS = [
  { value: "mapped", label: "Mapped" },
  { value: "pending", label: "Pending" },
  { value: "needs_review", label: "Needs Review" },
  { value: "failed", label: "Failed" },
] as const;

export type MappingReviewStatus =
  (typeof MAPPING_REVIEW_STATUS_OPTIONS)[number]["value"];
